import { render, staticRenderFns } from "./oldDetail.vue?vue&type=template&id=fd4f5c76&scoped=true"
import script from "./oldDetail.vue?vue&type=script&lang=js"
export * from "./oldDetail.vue?vue&type=script&lang=js"
import style0 from "./oldDetail.vue?vue&type=style&index=0&id=fd4f5c76&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd4f5c76",
  null
  
)

export default component.exports